import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'odin-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ForgotPasswordComponent {

  public loading: boolean;
  public email: string;

  constructor() {}

  public Submit(): void {

  }

}
